module.exports = __webpack_public_path__ + "img/Profesionalnost.1e69bdd9.jpg";